import { render, staticRenderFns } from "./FeedbackContent.vue?vue&type=template&id=772b5cac&scoped=true&"
import script from "./FeedbackContent.vue?vue&type=script&lang=ts&"
export * from "./FeedbackContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b5cac",
  null
  
)

export default component.exports